////////LIBRARY/////////
import React, { useEffect, useState, Fragment } from 'react'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { map, clone, cloneDeep, find, reject, isEmpty, includes, isUndefined } from 'lodash'
import { bindActionCreators } from 'redux'
import styled from 'styled-components'
///////COMPONENTS///////
import ListSearchable from '../../../components/ListSearchable'
import theme from '../../../theme/theme'
import { rolesManagerActionCreators } from '../../../store/actions'
import Button from '../../../components/Ui/Buttons'
import {
	PageGridTitle,
	PageGridBorder,
	SelectInputWrapper,
	SelectInput,
	InputLogin,
	SearchInputWrapper,
	SearchInputButton,
	SearchReset,
} from '../../../theme/GlobalCss'
import TooltipHelp from '../../../components/TooltipHelp'

//////STYLED//////
const RolesPrivilegesManagerWrapper = styled.div`
	position: relative;
`
const ListActions = styled.div`
	display: flex;
	flex-direction: column;
	flex-wrap: wrap;
`
const ButtonFiltersWrapper = styled.div`
	position: relative;
	padding: 10px;
	display: flex;
	flex-direction: row;
	& > * {
		margin: 0px 4px;
		font-size: ${(props) => props.theme.font.fs};
		:hover {
			color: ${(props) => props.theme.colors.blueColor};
		}
	}
`
const CategoriesWrapper = styled.div`
	display: flex;
	padding: 10px;
	& > * > select {
		font-size: ${(props) => props.theme.font.fs};
	}
`
const SearchPrivilegesWrapper = styled.div`
	position: relative;
	display: flex;
	margin: 10px;
	& > * > input {
		font-size: ${(props) => props.theme.font.fs};
	}
`
const OptionCustom = styled.option`
	color: ${(props) => props.target && props.theme.text.colors.primary};
`

const SelectInputCustom = styled(SelectInput)`
	color: ${(props) => (!props.selectTarget ? props.theme.colors.eraser : props.theme.text.colors.primary)};
`
//////STYLED//////

const RolesPrivilegesManager = (props) => {
	const [buttonFilters, setButtonFilters] = useState([0])
	const [categorySelected, setCategorySelected] = useState(0)
	const [searchValue, setSearchValue] = useState('')
	const [searched, setSearched] = useState('')
	const [checkedAll, setCheckedAll] = useState(false)
	const [selectTarget, setSelectTarget] = useState(false)

	const { translations, rolesManager } = useSelector(
		(state) => ({
			translations: state.languages.translations,
			rolesManager: state.rolesManager,
		}),
		shallowEqual
	)

	const [inputData, setInputData] = useState(rolesManager.roleDetail.privileges)

	const actionsRolesManager = bindActionCreators(rolesManagerActionCreators, useDispatch())

	///////////////////////////////// HANDLE ///////////////////////////////////////

	const handleButtonFilters = (idFilterButton) => {
		// Il All is clicked, unselect all other options
		if (idFilterButton === 0) {
			setButtonFilters([idFilterButton])
		} else {
			let newsButtonFilters = isEmpty(buttonFilters) ? [] : clone(buttonFilters)

			const f = find(newsButtonFilters, (o) => o === idFilterButton)

			if (isUndefined(f)) {
				// If All is selected and we have clicked another button, we remove All from list
				newsButtonFilters[0] === 0 ? (newsButtonFilters[0] = idFilterButton) : newsButtonFilters.push(idFilterButton)
			} else {
				newsButtonFilters = reject(newsButtonFilters, (o) => o === idFilterButton)
			}

			// If nothing left, we set All by default
			if (isEmpty(newsButtonFilters)) newsButtonFilters.push(0)
			setButtonFilters(newsButtonFilters)
		}
	}

	const handleInputData = () => {
		let newinputData = cloneDeep(rolesManager.roleDetail.privileges)
		// We want all privileges types that they ARE
		const contains_all_types = includes(config.filters.privilegeType, 0)
		const current_category = config.filters.privilegeCategorie

		if (!contains_all_types) {
			newinputData = reject(newinputData, (o) => {
				return includes(config.filters.privilegeType, o.privilegeType.id) ? false : true
			})
		}

		if (parseInt(current_category) > 0) {
			newinputData = reject(newinputData, (o) => {
				return parseInt(current_category) === o.privilegeCategorie.id ? false : true
				//return (includes(parseInt(current_category), o.privilegeCategorie.id)) ? false : true
			})
		}
		if (searchValue.length > 0) {
			newinputData = reject(newinputData, (o) => {
				const str = translations[o.translationKey].toUpperCase()
				return str.includes(searchValue.toUpperCase()) ? false : true
			})
		}

		setInputData(newinputData)
	}

	const handleChoiceTarget = () => {
		setSelectTarget(true)
	}

	useEffect(() => {
		// Whenever we change filters, we redraw the list
		handleInputData()
	}, [buttonFilters, categorySelected, searched])

	const handleCheckAll = (checkedAll) => {
		setCheckedAll(checkedAll)
	}

	const handleCategorySelected = (e) => {
		setCategorySelected(e.target.value)
	}

	const handleSearchValue = (e) => {
		setSearchValue(e.target.value)
	}

	const handleSearch = (e) => {
		setSearched(searchValue)
	}

	const handleSearchEnter = (e) => {
		if (e.keyCode === 13 || searchValue === '') setSearched(searchValue)
	}
	const handlerAlpha = (a, b) => {
		if (translations[a.translationKey] < translations[b.translationKey]) return -1
		else if (translations[a.translationKey] == translations[b.translationKey]) return 0
		else return 1
	}

	///////////////////////////////// CONFIG ///////////////////////////////////////

	const config = {
		name: `${translations['page__roleManagement__roleSheet_definition']} : ${rolesManager.roleDetail.role.label}`,
		labelSelected: `${translations['page__roleManagement__roleSheet_privilegeChecked']} :`,
		filters: {
			privilegeType: buttonFilters,
			privilegeCategorie: categorySelected,
			searchValue: searched,
		},
		textLinkSummary: `${translations['page__roleManagement__roleSheet_viewCheckedPrivilege']}`,
	}

	const columns = [
		// We set what data value is used to
		// For setting value of input
		{ isCheckboxValue: true, dataHook: 'id', headerName: 'id' },
		// For labelling the item
		{ isLabel: true, dataHook: 'translationKey', headerName: 'translationKey' },
	]

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<RolesPrivilegesManagerWrapper>
			<TooltipHelp content={'tooltipHelp__admin__modal__body__roleManagement__definitionRole'} insideModal={props.userMode}>
				<PageGridTitle>{config.name}</PageGridTitle>
			</TooltipHelp>
			<PageGridBorder>
				<ListActions>
					{rolesManager.roleDetail.filters && (
						<Fragment>
							<SearchPrivilegesWrapper>
								<SearchInputWrapper>
									<InputLogin
										value={searchValue}
										onChange={handleSearchValue}
										onKeyDown={handleSearchEnter}
										placeholder={translations['page__roleManagement__roleSheet_privilege_search']}
									/>
									<SearchInputButton onClick={handleSearch} />
								</SearchInputWrapper>
								{searchValue.length > 0 && (
									<SearchReset
										onClick={() => {
											setSearchValue('')
											setSearched('')
										}}
									/>
								)}
							</SearchPrivilegesWrapper>
							<CategoriesWrapper>
								<SelectInputWrapper blueColor>
									<SelectInputCustom
										width="246"
										name="idRightCategory"
										onChange={(e) => {
											handleCategorySelected(e)
											handleChoiceTarget()
										}}
										selectTarget={selectTarget}
									>
										<OptionCustom value="0" hidden>
											{translations['page__roleManagement__rolePage_privilegeCategory']}
										</OptionCustom>
										{map(rolesManager.roleDetail.filters.privilegeCategorie.sort(handlerAlpha), (elem, id) => {
											return (
												<OptionCustom key={id} value={elem.id} target={true}>
													{translations[elem.translationKey]}
												</OptionCustom>
											)
										})}
									</SelectInputCustom>
								</SelectInputWrapper>
							</CategoriesWrapper>
							<ButtonFiltersWrapper>
								{includes(config.filters.privilegeType, 0) ? (
									<Button actionHandler={() => handleButtonFilters(0)} text={translations['common__text__all']} height={32} />
								) : (
									<Button
										actionHandler={() => handleButtonFilters(0)}
										text={translations['common__text__all']}
										bgColor={theme.colors.white}
										color={theme.colors.primary}
										borderColor={theme.colors.primary}
										height={32}
									/>
								)}
								{map(rolesManager.roleDetail.filters.privilegeType, (item, id) => {
									const f = includes(config.filters.privilegeType, item.id) ? true : false
									return f ? (
										<Button
											actionHandler={() => handleButtonFilters(item.id)}
											text={translations[item.translationKey]}
											height={32}
										/>
									) : (
										<Button
											actionHandler={() => handleButtonFilters(item.id)}
											text={translations[item.translationKey]}
											bgColor={theme.colors.white}
											color={theme.colors.primary}
											borderColor={theme.colors.primary}
											height={32}
										/>
									)
								})}
							</ButtonFiltersWrapper>
						</Fragment>
					)}
				</ListActions>
				{rolesManager.roleDetail.privileges && (
					<ListSearchable
						inputData={inputData}
						inputColumns={columns}
						translationMode={true}
						hookList={props.setPrivilegesList}
						inputConfig={config}
						remoteCheckAll={checkedAll}
						remoteCheckAllFunc={handleCheckAll}
						summaryHandler={props.showRecap}
						summaryList={props.recapList}
						sizeHeightActions={546}
						readOnly={props.readOnly}
					/>
				)}
			</PageGridBorder>
		</RolesPrivilegesManagerWrapper>
	)
}

RolesPrivilegesManager.propTypes = {}

RolesPrivilegesManager.defaultPropTypes = {}

export default RolesPrivilegesManager
